const TempFileAPI = {


  upload(file) {

    var data = new FormData();
    data.append('file', file);

    return $cfg.API.post('/temp-file', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
  },
}

export { TempFileAPI }
